/**
* Web Service handler to transmit new Appointment information
*
* @class AddAppointmentWS
*/
function AddAppointmentWS (parent) {
	var self = this;

	AbstractWS.apply(this, arguments);


	self.addingTicket					        = ko.observable( false );
	self.appointmentConfirmationCode	= ko.observable( null );
	self.errorType						        = ko.observable( null );
	self.method							          = ko.observable( 'POST' );
	self.name							            = 'AddAppointmentWS';
	self.queueId						          = ko.observable( null );
	self.updateCustomPropsWS			    = new UpdateCustomPropsWS(self.parent);

	self.serviceURL	= ko.computed( function () {
		return '/qless/api/v1/appointment/queue/' + self.queueId() + '/appointment';
	});


	self.errorTypeRecoverable = ko.computed( function () {
		return ( self.errorType() == null || ['appointmentNoLongerAvailable'].indexOf( self.errorType() ) > -1 );
	});



	/**
	* Overrides the AbstractWS method to prevent unintentional invocation.
	* To add an appointment, the sendTicket() method is invoked.
	*
	* @method doRequest
	* @return {AddAppointmentWS} Returns the data model as chainable, for best practice
	*/
	self.doRequest = function ( callback ) {
		// Return self (AddAppointmentWS) to be chainable, for best practice
		return self;
	};



	// --------------------------------------------------------------------------
	//  Processes the WS data return
	// --------------------------------------------------------------------------

	self.processData = function ( xmlData ) {
		var confirmationCode = null
		var foundError = false
		var msgKey = 'unknownAppointmentError'
		var rootCause = null

		AbstractWS.prototype.processData.call( self, xmlData );

		self.addingTicket( false );

		if ( !self.checkResponseForError( self ) ) {
			// Hide the add appointment ticket interface
			qcal.addNewAppointmentHide();

			confirmationCode = $( xmlData ).find('appointment').attr('confirmationCode');

			if ( confirmationCode !== null ) {
				self.appointmentConfirmationCode( confirmationCode );
			}
			else {
				foundError = true;
			}
		}
		else {
			foundError = true;
		}

		if ( foundError == true ) {
			rootCause = $( xmlData ).find('error').attr('rootCauseType');

			switch ( rootCause ) {
				case 'AppointmentAlreadyScheduledException':
					msgKey = 'appointmentAlreadyScheduled';
					break;
				case 'NoAppointmentAvailableException':
					msgKey = 'appointmentNoLongerAvailable';
					break
				default:
					msgKey = 'unknownAppointmentError';
					break
			}

			self.errorType( msgKey );
			self.errorMessage( qcal.messagesWS.get(msgKey) );
		}
		else {
			qcal.sendAppointmentConfirmationEmail();
		}

		// Finally, update the appointmentWS to show the latest data
		qcal.appointmentsWS.doRequest();

	};



	/**
	* Reset observables back to null
	*
	* @method reset
	* @return {AddAppointmentWS} Returns the data model as chainable, for best practice
	*/
	self.reset = function () {
		AbstractWS.prototype.reset.call( self );

		self.addingTicket( false );
		self.appointmentConfirmationCode( null );
		self.queueId( null );
		self.errorType( null );

		// Return self (AddAppointmentWS) to be chainable, for best practice
		return self;
	};



	/**
	* Resets the errorMessage and errorType to null to allow the user to attempt to
	* select another appointment time
	*
	* @method resetError
	* @return {AddAppointmentWS} Returns the data model as chainable, for best practice
	*/
	self.resetError = function () {
		self.errorMessage( null );
		self.errorType( null );

		// Return self (AddAppointmentWS) to be chainable, for best practice
		return self;
	};



	/**
	* Overrides the AbstractWS method to prevent unintentional invocation.
	* To add an appointment, the sendTicket() method is invoked.
	*
	* @method sendTicket
	* @param {AddAppointmentTicket} oAppointmentTicket Data model representing add appointment data
	* @return {AddAppointmentWS} Returns the data model as chainable, for best practice
	*/
	self.sendTicket = function ( oAppointmentTicket ) {
		var iCustomPropLen = 0;
		var m = null;
		var tz = ( oAppointmentTicket.timeZone() != null ) ? oAppointmentTicket.timeZone() : oAppointmentTicket.location().timeZone;

		// Clear out any pre-existing data loaded in the object
		self.reset();

		m = new moment( oAppointmentTicket.start() );
		m.tz( tz );

		// Required parameters
		self.addParam( 'queueId', oAppointmentTicket.queueId() );
		self.addParam( 'phone', qcal.getPhoneWithCountryCode( oAppointmentTicket.phone(), oAppointmentTicket.location().defaultPhoneCountryCode ) );

		self.addParam( 'start', m.format('YYYY-MM-DDTHH:mm:ssZ') );

		// Optional parameters
		if ( oAppointmentTicket.notes() != null ) {
			self.addParam( 'notes', oAppointmentTicket.notes() );
		}

		if ( oAppointmentTicket.partySize() != null ) {
			self.addParam( 'partySize', oAppointmentTicket.partySize() );
		}

		if ( oAppointmentTicket.transactionTypeId() != null ) {
			self.addParam( 'transactionTypeId', oAppointmentTicket.transactionTypeId() );
		}

		self.addParam( 'timeZone', tz );

		if ( oAppointmentTicket.language() != null ) {
			self.addParam( 'locale', oAppointmentTicket.language() );
		}

		if ( oAppointmentTicket.resourceId() != null ) {
			self.addParam( 'resourceId', oAppointmentTicket.resourceId() );
    }

    self.addParam( 'source', 'CALENDAR' );

		// Read out and pack any custom screen fields
		self.updateCustomPropsWS.reset();
		self.updateCustomPropsWS.locationId( oAppointmentTicket.location().id );

		for ( prop in oAppointmentTicket.customProps() ) {
			if ( oAppointmentTicket.customProps().hasOwnProperty( prop ) ) {
        ++iCustomPropLen;
        // If the custom property is supposed to go with the appointment, add it
        if ( self.parent.featureToggles().submitAppointmentCustomProps ) {
          self.addParam( 'appointment_prop-' + prop, oAppointmentTicket.customProps()[ prop ]() );
        }
        // Else add the custom property to the consumer updateCustomProps call
        else {
          self.updateCustomPropsWS.addParam( prop, oAppointmentTicket.customProps()[ prop ]() );
        }
			}
		}

    // If the custom properties are not configured to be sent as appointment
    // custom properties, then go ahead and update the custom properties
    if ( self.parent.featureToggles().submitAppointmentCustomProps != true ) {
      if ( iCustomPropLen > 0 ) {
        self.updateCustomPropsWS.addParam( 'phone', qcal.getPhoneWithCountryCode( oAppointmentTicket.phone(), oAppointmentTicket.location().defaultPhoneCountryCode ) );
        self.updateCustomPropsWS.doRequest();
      }
    }


		// Calculate a serviceURL based on the queueId
		self.serviceURL	= ko.computed( function () {
			return '/qless/api/v1/appointment/queue/' + oAppointmentTicket.queueId() + '/appointment';
		});

		self.addingTicket( true );

		AbstractWS.prototype.doRequest.call( self );

		// Return self (AddAppointmentWS) to be chainable, for best practice
		return self;
	};


	// Return self (AddAppointmentWS) to be chainable, for best practice
	return self;
};

AddAppointmentWS.prototype = AbstractWS.prototype;
AddAppointmentWS.prototype.constructor = AddAppointmentWS;
